import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

import { useSentimentEffects } from '../hooks/useSentimentEffects';
import { SentimentEffectsChart } from './SentimentEffectsChart';

interface SentimentDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  companyRcid: number | null;
  companyName: string | null;
}

export const SentimentDetailModal = ({
  isOpen,
  onClose,
  companyRcid,
  companyName,
}: SentimentDetailModalProps) => {
  // Only fetch when the modal is open
  const { data, isLoading } = useSentimentEffects(isOpen ? companyRcid : null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent maxH="85vh">
        <ModalHeader pb={2}>
          <Text fontSize="md" fontWeight="bold" color="gray.800">
            {companyName ?? 'Company'} — Sentiment Topics
          </Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <SentimentEffectsChart
            data={data}
            isLoading={isLoading}
            companyName={companyName}
            height={400}
          />

          <Text fontSize="xs" color="gray.400" mt={3}>
            Top sentiment topics by effect, weighted by review count. Positive
            factors drive hiring; negative factors drive attrition.
          </Text>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
